var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotoLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_491_4682",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_491_4682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.59491 9.00539L7.6898 7.85539C7.63573 7.77933 7.56756 7.74129 7.4853 7.74129C7.40304 7.74129 7.33488 7.78146 7.28081 7.86179L6.37955 9.06563C6.31033 9.15708 6.29924 9.25196 6.3463 9.35024C6.39336 9.44853 6.47154 9.49768 6.58083 9.49768H11.4859C11.5952 9.49768 11.6734 9.44853 11.7205 9.35024C11.7675 9.25196 11.7586 9.15708 11.6936 9.06563L10.3539 7.25794C10.2998 7.1776 10.2306 7.13743 10.1462 7.13743C10.0618 7.13743 9.99257 7.1776 9.93851 7.25794L8.59491 9.00539ZM5.23853 11.6669C4.93844 11.6669 4.68479 11.5633 4.47758 11.3561C4.27036 11.1488 4.16675 10.8952 4.16675 10.5951V3.00539C4.16675 2.70531 4.27036 2.45165 4.47758 2.24443C4.68479 2.03721 4.93844 1.93359 5.23853 1.93359H12.8282C13.1283 1.93359 13.382 2.03721 13.5892 2.24443C13.7964 2.45165 13.9 2.70531 13.9 3.00539V10.5951C13.9 10.8952 13.7964 11.1488 13.5892 11.3561C13.382 11.5633 13.1283 11.6669 12.8282 11.6669H5.23853ZM5.23853 10.8002H12.8282C12.8795 10.8002 12.9265 10.7789 12.9693 10.7361C13.012 10.6934 13.0334 10.6464 13.0334 10.5951V3.00539C13.0334 2.95411 13.012 2.90709 12.9693 2.86434C12.9265 2.82161 12.8795 2.80024 12.8282 2.80024H5.23853C5.18724 2.80024 5.14023 2.82161 5.0975 2.86434C5.05475 2.90709 5.03338 2.95411 5.03338 3.00539V10.5951C5.03338 10.6464 5.05475 10.6934 5.0975 10.7361C5.14023 10.7789 5.18724 10.8002 5.23853 10.8002ZM3.17188 13.7335C2.8718 13.7335 2.61815 13.6299 2.41093 13.4227C2.20371 13.2155 2.1001 12.9618 2.1001 12.6617V4.63871C2.1001 4.51572 2.14124 4.41276 2.22351 4.32981C2.30578 4.24687 2.40791 4.20539 2.52991 4.20539C2.6519 4.20539 2.75521 4.24687 2.83983 4.32981C2.92444 4.41276 2.96675 4.51572 2.96675 4.63871V12.6617C2.96675 12.713 2.98811 12.76 3.03085 12.8028C3.07359 12.8455 3.1206 12.8669 3.17188 12.8669H11.1949C11.3179 12.8669 11.4209 12.908 11.5038 12.9903C11.5868 13.0726 11.6282 13.1747 11.6282 13.2967C11.6282 13.4187 11.5868 13.522 11.5038 13.6066C11.4209 13.6912 11.3179 13.7335 11.1949 13.7335H3.17188Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoLibrary);
export default __webpack_public_path__ + "static/media/photo_library.681b2c9a30eb73199ae43c3c3edd0ee5.svg";
export { ForwardRef as ReactComponent };